function pricelistsController(DatatableLang, $translate, $scope, $window, $state, WS) {
    'ngInject';

    const vm = this;
    const PER_PAGE = 50;

    // pricelist_code is only present in the url when editing an existing pricelist
    vm.pricelistCode = $state.params.pricelist_code || '';
    vm.isNew = !vm.pricelistCode;

    vm.pricelists = [];
    vm.pricelist = {
        pricelist_Code: vm.pricelistCode,
        pricelist_Name: '',
        date_debut: '',
        date_fin: '',
        produits: []
    };

    vm.selectedProduitCode = '';
    vm.produitsLoading = false;
    vm.produitsHasMore = true;
    vm.produitsPage = 0;

    vm.get = function () {
        WS.get('pricelistsweb')
            .then(function (response) {
                if (response.status == 200) {
                    vm.pricelists = response.data;

                    $scope.$apply();

                    $('.table').DataTable({
                        destroy: true,
                        "language": DatatableLang
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    // prefill the header (name/dates) when editing an existing pricelist
    vm.show = function () {
        if (vm.isNew) {
            return;
        }

        WS.get('pricelistsweb/header/' + vm.pricelistCode)
            .then(function (response) {
                if (response.data) {
                    vm.pricelist.pricelist_Code = response.data.pricelist_Code;
                    vm.pricelist.pricelist_Name = response.data.pricelist_Name;
                    vm.pricelist.date_debut = response.data.date_debut;
                    vm.pricelist.date_fin = response.data.date_fin;
                }

                $scope.$apply();
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    vm.getParametrage = function () {
        WS.get('parametrages/getIndexForDashboard')
            .then(function (response) {
                vm.parametrages = response.data;
                $scope.$apply();

                if (vm.parametrages.useSelectOnChargement == 1) {
                    vm.selectProduit();

                    if (!vm.isNew) {
                        vm.getItems();
                    }
                } else {
                    vm.loadProduits(true);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    // select-produit mode: dropdown of active produits to add one by one
    vm.selectProduit = function () {
        WS.get('produits/selectProduit')
            .then(function (response) {
                vm.produits = response.data;
                $scope.$apply();
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    // keeps only the first occurrence of each item_Code (defends ng-repeat against dupes)
    function dedupeByItemCode(list) {
        var seen = {};

        return list.filter(function (item) {
            if (seen[item.item_Code]) {
                return false;
            }

            seen[item.item_Code] = true;
            return true;
        });
    }

    // select-produit mode: produits already priced in this pricelist
    vm.getItems = function () {
        WS.get('pricelistsweb/items/' + vm.pricelistCode)
            .then(function (response) {
                var items = (response.data || []).map(function (item) {
                    item._persisted = true;
                    return item;
                });

                vm.pricelist.produits = dedupeByItemCode(items);

                $scope.$apply();
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    vm.ajouterProduit = function () {
        if (!vm.selectedProduitCode) {
            return;
        }

        var alreadyAdded = vm.pricelist.produits.some(function (p) {
            return p.item_Code == vm.selectedProduitCode;
        });

        if (alreadyAdded) {
            swal(
                $translate.instant('Attention'),
                $translate.instant('Ce produit est déjà ajouté à la liste'),
                'warning'
            );
            return;
        }

        var produit = vm.produits.filter(function (p) {
            return p.code == vm.selectedProduitCode;
        })[0];

        if (!produit) {
            return;
        }

        vm.pricelist.produits.push({
            item_Code: produit.code,
            item_Name: produit.libelle,
            price_HT: produit.prix_ht || 0,
            price_TTC: produit.prix_ttc || 0,
            _persisted: false
        });

        vm.selectedProduitCode = '';
    };

    // select-produit mode: remove a produit (deletes it right away if it was already saved)
    vm.removeProduit = function (index) {
        var produit = vm.pricelist.produits[index];

        if (!produit._persisted) {
            vm.pricelist.produits.splice(index, 1);
            return;
        }

        swal({
            title: $translate.instant('Supprimer'),
            text: $translate.instant('Voulez-vous supprimer ce produit de la pricelist ?'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: $translate.instant('Oui'),
            cancelButtonText: $translate.instant('Non'),
        }).then(function () {
            WS.delete('pricelistsweb/' + vm.pricelistCode + '/item/' + produit.item_Code)
                .then(function () {
                    vm.pricelist.produits.splice(index, 1);
                    $scope.$apply();
                })
                .catch(function (error) {
                    console.log(error);
                });
        }, function () {});
    };

    // table mode: load the active produits catalog page by page (lazy loading)
    vm.loadProduits = function (reset) {
        if (vm.produitsLoading || (!reset && !vm.produitsHasMore)) {
            return;
        }

        if (reset) {
            vm.pricelist.produits = [];
            vm.produitsPage = 0;
            vm.produitsHasMore = true;
        }

        var nextPage = vm.produitsPage + 1;
        var url = vm.isNew
            ? 'pricelistsweb/details'
            : 'pricelistsweb/details/' + vm.pricelistCode;

        vm.produitsLoading = true;

        WS.getData(url, { page: nextPage, perpage: PER_PAGE })
            .then(function (response) {
                var page = response.data.data || response.data;

                vm.pricelist.produits = dedupeByItemCode(vm.pricelist.produits.concat(page));
                vm.produitsPage = nextPage;
                vm.produitsHasMore = page.length === PER_PAGE;
                vm.produitsLoading = false;

                $scope.$apply();
            })
            .catch(function (error) {
                vm.produitsLoading = false;
                console.log(error);
            });
    };

    // called on window scroll (table mode) to fetch the next page near the bottom
    vm.onProduitsScroll = function () {
        if (vm.parametrages && vm.parametrages.useSelectOnChargement != 1) {
            vm.loadProduits(false);
        }
    };

    angular.element($window).on('scroll', function () {
        if ($window.innerHeight + $window.scrollY >= document.body.offsetHeight - 200) {
            vm.onProduitsScroll();
        }
    });

    $scope.$on('$destroy', function () {
        angular.element($window).off('scroll');
    });

    vm.save = function () {

        if (vm.saving) {
            return;
        }

        if (!vm.pricelist.pricelist_Code) {
            swal(
                $translate.instant('Erreur'),
                $translate.instant('Le code est obligatoire'),
                'error'
            );
            return;
        }

        vm.saving = true;

        WS.post('pricelistsweb/create-or-update', vm.pricelist)
            .then(function (response) {

                vm.saving = false;

                if (response.data.success == true) {

                    var savedCode = vm.pricelist.pricelist_Code;

                    swal(
                        $translate.instant('Succès'),
                        $translate.instant('Pricelist saved successfully'),
                        'success'
                    ).then(function () {
                        $window.location.href = '/pricelists/' + savedCode;
                    });

                } else {
                    $scope.$apply();
                    swal(
                        $translate.instant('Erreur'),
                        $translate.instant(response.data.message),
                        'error'
                    );
                }

            })
            .catch(function (error) {
                vm.saving = false;
                $scope.$apply();
                console.log(error);
            });
    };

    vm.delete = function (code) {

        swal({
            title: $translate.instant('Supprimer'),
            text: $translate.instant("Voulez-vous supprimer ce pricelist ?"),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: $translate.instant('Oui'),
            cancelButtonText: $translate.instant('Non'),
        }).then(function () {

            WS.delete('pricelistsweb/' + code)
                .then(function () {

                    swal(
                        $translate.instant('Succès'),
                        $translate.instant('Pricelist supprimé avec succès'),
                        'success'
                    ).then(function () {
                        $window.location.reload();
                    });

                })
                .catch(function () {
                    swal(
                        $translate.instant('Erreur'),
                        $translate.instant('Suppression impossible'),
                        'error'
                    );
                });

        }, function (error) {
            console.log(error);
        });
    };
}

export default {
    name: 'pricelistsController',
    fn: pricelistsController
};
